import React, { useState, useContext } from 'react';
import styled from 'styled-components';
import { Select, Input } from 'antd';
import { v4 as uuidv4 } from 'uuid';

import duplicateIcon from 'assets/svgs/ion_duplicate-outline.svg';
import deleteIcon from 'assets/svgs/fluent_delete-48-filled.svg';
import AppText from 'components/common/AppText';
import { SurveyContext } from 'context/SurveyContext';
import AddOption from './AddOption';
import AddRating from './AddRating';
import SurveySubmit from './SurveySubmit';

const { Option } = Select;
const { TextArea } = Input;

const SurveyForm = ({ setCreateSurvey }) => {
  const [questions, setQuestions] = useState([{ id: uuidv4(), questionType: '2' }]);
  const { setSurvey, survey } = useContext(SurveyContext);
  const questionType = ['', 'Multiple Choice', 'FreeText', 'Rating'];

  // React.useEffect(() => {
  //   console.log('survey', survey);
  // }, [survey]);

  // React.useEffect(() => {
  //   console.log('questions', questions);
  // }, [questions]);

  React.useEffect(() => {
    setSurvey(prev => ({ ...prev, questions }));
  }, [questions]);

  const handleChange = (value, option) => {
    if (option) {
      setQuestions(prev => {
        const existingOption = prev?.find(el => el.id === option.key);
        if (existingOption) {
          prev[prev.indexOf(existingOption)] = {
            ...existingOption,
            id: option.key,
            questionType: value
          };
          return [...prev];
        } else {
          return [...prev, { id: option.key, questionType: value, options: null }];
        }
      });
    } else {
      value.persist();
      setQuestions(prev => {
        const existingOption = prev?.find(el => el.id === value?.target?.id);
        if (existingOption) {
          prev[prev.indexOf(existingOption)] = {
            ...existingOption,
            id: value.target.id,
            question: value.target.value
          };
          return [...prev];
        } else {
          return [...prev, { id: value.target.id, question: value.target.value }];
        }
      });
    }
  };

  const isMultipleChoice = id => questions.find(el => el.id == id && el.questionType == '1');

  const isRating = id => questions.find(el => el.id == id && el.questionType == '3');

  const handleDelete = id => {
    setQuestions(prev =>
      prev.length === 1 ? [{ id: uuidv4(), questionType: '2' }] : prev.filter(el => el.id !== id)
    );
  };

  const handleDuplicate = questionType => {
    setQuestions(prev => [...prev, { id: uuidv4(), questionType }]);
  };

  return (
    <Container>
      {questions.map((question, index) => (
        <Div key={question.id}>
          <FormHeader>
            <AppText
              value={`Question ${index + 1}`}
              weight="500"
              size="16px"
              color="#000"
              bottom={0}
            />
            <IconDiv>
              <Img src={duplicateIcon} onClick={() => handleDuplicate(question.questionType)} />
              <Img src={deleteIcon} onClick={() => handleDelete(question.id)} />
            </IconDiv>
          </FormHeader>
          <FormContent>
            <Select
              defaultValue={questionType[question.questionType]}
              style={{ width: '100%', marginBottom: '1rem' }}
              onChange={handleChange}>
              <Option value="2" key={question.id}>
                Free Text
              </Option>
              <Option value="1" key={question.id}>
                Multiple Choice
              </Option>
              <Option value="3" key={question.id}>
                Rating
              </Option>
            </Select>
            <TextArea
              rows={2}
              placeholder="Type Question"
              onChange={handleChange}
              id={question.id}
            />
          </FormContent>
          {isMultipleChoice(question.id) ? (
            <AddOption setQuestions={setQuestions} questionId={question.id} />
          ) : (
            isRating(question.id) && (
              <AddRating setQuestions={setQuestions} questionId={question.id} />
            )
          )}
        </Div>
      ))}
      <SurveySubmit setCreateSurvey={setCreateSurvey} />
    </Container>
  );
};

export default SurveyForm;

const Container = styled.div``;

const Div = styled.div`
  margin-bottom: 2rem;
  display: flex;
  gap: 0.5rem;
  flex-direction: column;
`;
const FormHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;
const IconDiv = styled.div`
  display: flex;

  gap: 1rem;
  width: 70px;
  justify-content: center;
  height: 31px;
  background: rgba(231, 244, 255, 0.51);
  border-radius: 3px;
`;

const Img = styled.img`
  align-self: center;
  cursor: pointer;
  transition: all 0.2s ease-out;
  &:hover {
    transform: scale(1.1);
  }
`;

const FormContent = styled.div``;
